import { isDataGridScope } from '../helpers';
import { AppStructureBuilderError } from './error';
export function addScope({ scopeName, scopeType, viewName, entityName, filterQuery, }) {
    if (!this.schema.model.entities[entityName]) {
        throw new AppStructureBuilderError(`Entity ${entityName} not found`);
    }
    if (!scopeType) {
        throw new AppStructureBuilderError('Scope type is not defined');
    }
    this.updateAppStructure(draftBuilder => {
        var _a;
        const { view } = draftBuilder.getScopeByView({ scopeName, viewName, throwOnError: false });
        const scope = view?.scopes[scopeName] || draftBuilder.newScope({ scopeName, scopeType, entityName, filterQuery });
        if (isDataGridScope(scope)) {
            scope.filter = filterQuery;
        }
        if (!view) {
            draftBuilder.application.views[viewName] = {
                name: viewName,
                scopes: { [scopeName]: scope },
            };
        }
        else {
            (_a = view.scopes)[scopeName] ?? (_a[scopeName] = scope);
        }
    });
    return this;
}
export function removeScope({ scopeName, viewName }) {
    this.updateAppStructure(draftBuilder => {
        if (!viewName) {
            const views = this.getViewsByScopeName(scopeName);
            for (const view of views) {
                if (view && this.getView(view.name)) {
                    delete draftBuilder.application.views[view.name].scopes[scopeName];
                }
            }
        }
        else {
            if (!this.application.views[viewName]) {
                throw new AppStructureBuilderError(`View ${viewName} not found`);
            }
            delete draftBuilder.application.views[viewName].scopes[scopeName];
        }
    });
    return this;
}
export function addFilterScope({ scopeName, viewName, filterQuery }) {
    this.updateAppStructure(draftBuilder => {
        const { scope } = draftBuilder.getScopeByView({ scopeName: scopeName, viewName });
        if (!scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        if (scope.type !== 'dataGrid') {
            throw new AppStructureBuilderError(`Scope ${scopeName} is not a data grid`);
        }
        scope.filter = filterQuery;
    });
    return this;
}
export function removeFilterScope({ scopeName, viewName }) {
    this.updateAppStructure(draftBuilder => {
        const { scope } = draftBuilder.getScopeByView({ scopeName: scopeName, viewName });
        if (!scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        if (scope.type !== 'dataGrid') {
            throw new AppStructureBuilderError(`Scope ${scopeName} is not a data grid`);
        }
        scope.filter = undefined;
    });
    return this;
}
export function allowScope({ roles, scopeName, viewName }) {
    this.updateAppStructure(draftBuilder => {
        const { scope } = draftBuilder.getScopeByView({ scopeName, viewName });
        if (!scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        scope.roles = roles;
    });
    return this;
}
export function denyScope({ roles, scopeName, viewName }) {
    this.updateAppStructure(draftBuilder => {
        const schemaRoles = this.schema.acl.roles;
        const { scope } = draftBuilder.getScopeByView({ scopeName, viewName });
        if (!scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        scope.roles = Object.keys(schemaRoles).filter(role => !roles.includes(role));
    });
    return this;
}
//# sourceMappingURL=scopeManagement.js.map